import {ROUTE_TYPES} from "~/navigation/routes";

export default function isModelNavigation(type) {
    switch(type) {
        case ROUTE_TYPES.ALL_MODELS:
        case ROUTE_TYPES.SUBVIEW:
        case ROUTE_TYPES.VIEW_ENTRY:
            return true;
    }
    
    return false;
}